import { collection, doc, increment, serverTimestamp, writeBatch } from 'firebase/firestore';
import { db } from '../firebase.js';

function outcomeFor(scoreA, scoreB) {
  if (scoreA > scoreB) return { wins: 1, losses: 0, ties: 0 };
  if (scoreA < scoreB) return { wins: 0, losses: 1, ties: 0 };
  return { wins: 0, losses: 0, ties: 1 };
}

/**
 * player1/player2 are either { id } for an existing player
 * or { name, username } to create a new player at save time.
 */
export function useGameSave() {
  async function saveGame({ player1, player2, player1Score, player2Score, datePlayed, savedByUserId }) {
    const batch = writeBatch(db);

    const player1Ref = player1.id ? doc(db, 'players', player1.id) : doc(collection(db, 'players'));
    const player2Ref = player2.id ? doc(db, 'players', player2.id) : doc(collection(db, 'players'));
    const gameRef = doc(collection(db, 'games'));
    const homepageRef = doc(db, 'homepage', 'standings');

    const outcome1 = outcomeFor(player1Score, player2Score);
    const outcome2 = outcomeFor(player2Score, player1Score);

    const player1Update = {
      ...(player1.id ? {} : { name: player1.name, username: player1.username }),
      wins: increment(outcome1.wins),
      losses: increment(outcome1.losses),
      ties: increment(outcome1.ties),
      gamesPlayed: increment(1),
      totalPointsFor: increment(player1Score),
      totalPointsAgainst: increment(player2Score),
    };
    const player2Update = {
      ...(player2.id ? {} : { name: player2.name, username: player2.username }),
      wins: increment(outcome2.wins),
      losses: increment(outcome2.losses),
      ties: increment(outcome2.ties),
      gamesPlayed: increment(1),
      totalPointsFor: increment(player2Score),
      totalPointsAgainst: increment(player1Score),
    };

    batch.set(player1Ref, player1Update, { merge: true });
    batch.set(player2Ref, player2Update, { merge: true });

    batch.set(gameRef, {
      type: 'in-person',
      onlineGameId: null,
      player1Id: player1Ref.id,
      player2Id: player2Ref.id,
      player1Score,
      player2Score,
      datePlayed,
      dateSaved: serverTimestamp(),
      savedByUserId: savedByUserId ?? null,
    });

    batch.set(homepageRef, {
      players: {
        [player1Ref.id]: {
          ...(player1.id ? {} : { name: player1.name, username: player1.username }),
          wins: increment(outcome1.wins),
          losses: increment(outcome1.losses),
          ties: increment(outcome1.ties),
          gamesPlayed: increment(1),
        },
        [player2Ref.id]: {
          ...(player2.id ? {} : { name: player2.name, username: player2.username }),
          wins: increment(outcome2.wins),
          losses: increment(outcome2.losses),
          ties: increment(outcome2.ties),
          gamesPlayed: increment(1),
        },
      },
    }, { merge: true });

    await batch.commit();

    return { gameId: gameRef.id, player1Id: player1Ref.id, player2Id: player2Ref.id };
  }

  return { saveGame };
}
